import { createContext } from "react";
import type { GetUserOutput } from "../../../utils/trpc";

type User = GetUserOutput;

type UserContextType = {
  user: User | null | undefined;
  addNewRecentSearch: (newSearch: User["recentSearches"][number]) => void;
  isLoading: boolean;
};

export const UserContext = createContext<UserContextType | undefined>(
  undefined,
);
